// extracted by mini-css-extract-plugin
export default {"BreakpointDesktop":"Frame_BreakpointDesktop__4WcNg","ContentScreenStyling":"Frame_ContentScreenStyling__j9X3+","ContentScreen":"Frame_ContentScreen__ZXT0F"};